/**
 * @generated SignedSource<<f17378b17907758315b5c61b76ddcede>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicCollectionHeaderRelatedLinksConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly name?: string;
      readonly urlAlias?: string;
    };
  }>;
  readonly " $fragmentType": "topicCollectionHeaderRelatedLinksConnection";
};
export type topicCollectionHeaderRelatedLinksConnection$key = {
  readonly " $data"?: topicCollectionHeaderRelatedLinksConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicCollectionHeaderRelatedLinksConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicCollectionHeaderRelatedLinksConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QueueItemsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlAlias",
                  "storageKey": null
                }
              ],
              "type": "Topic",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemConnection",
  "abstractKey": null
};

(node as any).hash = "4caf8f1b3140a83678c1fbddf885e5be";

export default node;
